import GallectionDeviationSelector from './GallectionDeviationSelector';
export default GallectionDeviationSelector;

//# sourceMappingURL=index.js.map